let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7KTTm")).then(() => parcelRequire('gE8ze'));